import React from "react";
import AboutFeature from "./AboutFeature";

const WhyChooseUs = () => {
  return (
    <div className="about_why_choose_us container">
      <p
        style={{
          color: "#000",
          fontSize: "18px",
          marginBottom: "5px",
          position: "relative",
          width: "fit-content",
        }}
      >
        Our Differentiator
        <span
          style={{
            position: "absolute",
            bottom: "0px",
            left: "0px",
            right: "0px",
            height: "2px",
            background:
              "linear-gradient(to right, #006bff, #006bff 50%, #ff8000 50%)",
          }}
        ></span>
      </p>

      <h5 style={{ fontSize: "32px" }}>
      Why Choose Us?
      </h5>
      <p style={{marginTop:"8px", textAlign:"center", width:"100%"}}>
      Unlike traditional online courses that leave learners stranded after theory, Metbrains provides:
      </p>
    </div>
  );
};

export default WhyChooseUs;
